import type { CalculatorReport } from '#/modules/salary/types/CalculatorReport';
import type { SalariesCompensationSurveyData } from '#/modules/salary/types/SalariesCompensationSurveyData';
import type { BackgroundTask } from '#/utils/asyncBackendTask/asyncBackendTaskTypes';
import { postJson } from '#/utils/http/postJson';

import { SALARIES_API_ENDPOINT_ROOT } from './salaryApiEndpointRoot';

export async function salaryApiSubmitCompensationSurvey(
  compensationSurveyData: SalariesCompensationSurveyData,
): Promise<BackgroundTask<CalculatorReport>> {
  return postJson<{ task: BackgroundTask<CalculatorReport> }>(
    `${SALARIES_API_ENDPOINT_ROOT}${
      compensationSurveyData.source === 'TEST' ? '?test=true' : ''
    }`,
    compensationSurveyData,
  ).then(({ task }) => task);
}
